import { type ReactElement, type SVGProps } from 'react';

export const SurfaceOfficeIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m3.5 1.793 1.854 1.854-.708.707L4 3.707v13.086l.646-.646.708.707L3.5 18.708l-1.854-1.854.708-.707.646.646V3.707l-.646.647-.708-.707L3.5 1.793ZM11 3v2H7v12h14V3H11Zm1 13h8V4h-8v12Zm-1 0V6H8v10h3Zm4-10h-1v3h1V6Zm-1 8v-3h1v3h-1Zm-5-2v2h1v-2H9Zm0-2V8h1v2H9Zm9-4h-1v3h1V6Zm-1 8v-3h1v3h-1Zm5.207 6.5-1.853-1.854-.707.708.646.646H7.207l.647-.646-.708-.707L5.293 20.5l1.853 1.854.708-.707L7.207 21h13.086l-.646.646.707.708 1.854-1.854Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
